import { redirect } from "react-router"

export async function loader() {
  const { authPayload } = await window.domain.GetAuthPayloadAuthUseCase.execute()

  if (authPayload) {
    return redirect("/dashboard")
  }

  return null
}
